import { cn } from "@/lib/utils";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import ConciergeListingsPanel from "@/components/concierge/ConciergeListingsPanel";
import type { ConciergeCard } from "@/hooks/useAiConcierge";
import { useIsMobile } from "@/hooks/use-mobile";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  cards: ConciergeCard[];
  onOpenDetail: (slug: string) => void;
  /** Raise above the z-[100] home overlay. */
  elevated?: boolean;
}

/**
 * Every listing the conversation has surfaced, on demand: a bottom sheet on
 * phones, a right-hand sheet on desktop. The home widget's desktop layout has
 * the panel always open instead; this is for the inbox and for phones.
 */
const ConciergeMatchesSheet = ({ open, onOpenChange, cards, onOpenDetail, elevated = false }: Props) => {
  const isMobile = useIsMobile();
  const z = elevated ? "z-[120]" : undefined;
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side={isMobile ? "bottom" : "right"}
        overlayClassName={z}
        className={cn(
          "flex flex-col p-0",
          isMobile ? "h-[85dvh] rounded-t-2xl" : "w-full sm:max-w-xl",
          // Only the right-hand sheet needs to cover the navbar; on a bottom
          // sheet top-0 would hang it from the top of the screen.
          elevated && !isMobile && "top-0",
          z,
        )}
      >
        <SheetTitle className="sr-only">Your matches</SheetTitle>
        <ConciergeListingsPanel
          cards={cards}
          gridClassName="grid-cols-2"
          onOpenDetail={(slug) => {
            onOpenChange(false);
            onOpenDetail(slug);
          }}
        />
      </SheetContent>
    </Sheet>
  );
};

export default ConciergeMatchesSheet;
